import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import * as api from "api/api";
import { loginReset } from "redux/slice/authentication";
import { PingResource } from "api/resource/ping";
import { NewPing } from "model/ping";

export interface PingState {
	loading?: boolean;
	error?: string | null;
	ping?: PingResource;
};

const initialState: PingState = {
};

const createPing = createAsyncThunk("ping/createPing", async (payload: {ping: NewPing}, thunkAPI) => {
	thunkAPI.dispatch(pingLoading());
	const result = api.createPing(payload.ping);
	result
		.then(ping => thunkAPI.dispatch(pingLoaded(ping)))
		.catch(error => thunkAPI.dispatch(pingFailed(error)));
	return result;
});

export const pingSlice = createSlice({
	name: "ping",
	initialState,
	reducers: {
		pingLoading: (state) => {
			state.loading = true;
		},
		pingLoaded: (state, action: PayloadAction<PingResource>) => {
			state.loading = false;
			state.error = null;
			state.ping = action.payload;
		},
		pingFailed: (state, action: PayloadAction<string>) => {
			state.loading = false;
			state.error = action.payload;
		},
		default: (state) => {
            return state;
        }
    },
    extraReducers(builder) {
        builder.addCase(loginReset, (state) => {
			return {
				...initialState,
				error: state.error,
			};
		});
    }
});

export const { pingLoading, pingLoaded, pingFailed } = pingSlice.actions;
export { createPing };